import moment from 'moment';
import React from 'react';
import { getActiveLanguage, getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import TimePicker from './24hTimePicker/TimePicker';

class TimeData extends React.Component {
  render() {
    const {
      translate,
      editStateImportedTime,
      onHandleChange24hTimePicker,
      currentDateFromDB,
      currentDataFromDB,
      required,
      currentFormStatus,
      statusValues,
    } = this.props;

    let currentSelectedStartDateFromDB;
    let currentSelectedEndDateFromDB;
    const restTimePicker = currentDataFromDB.value.endsWith('_CUSTOMER_UNREACHABLE') !== currentFormStatus.value.endsWith('_CUSTOMER_UNREACHABLE');
    if (currentDateFromDB.length !== 0) {
      currentSelectedStartDateFromDB = new Date(currentDateFromDB[currentDateFromDB.length - 1].startDate);
      currentSelectedEndDateFromDB = new Date(currentDateFromDB[currentDateFromDB.length - 1].endDate);
    }
    return (
      <div>
        <div className="row date-reason-padding">
          <div className="col-lg-3 col-md-12">
            <div className="row">
              <div className="col-sm-12">
                <h3>{translate('service_installation.select_date')}</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-md-12">
            <div className="row">
              <div className="col-sm-12">
                <h3>{translate('service_installation.select_time')}</h3>
              </div>
            </div>
            <div className="row display-flex">
              <div className="col-xs-6">
                <TimePicker selectedTime={onHandleChange24hTimePicker}
                            required={required}
                            isStartTime
                            restTimePicker={restTimePicker}
                            currentHour={(currentSelectedStartDateFromDB === undefined || restTimePicker) ? null : currentSelectedStartDateFromDB.getHours()}
                            currentStartTimeFromDB={currentSelectedStartDateFromDB}
                            currentMin={(currentSelectedStartDateFromDB === undefined || restTimePicker) ? null : currentSelectedStartDateFromDB.getMinutes()} />
              </div>
              {currentFormStatus.value !== (statusValues.WEB_TO_WEB_CUSTOMER_UNREACHABLE || statusValues.APK_TO_WEB_CUSTOMER_UNREACHABLE)
                  && (
                  <div>
                    <span className="range-separator">&mdash;</span>
                  </div>
                  )}
              {currentFormStatus.value !== (statusValues.WEB_TO_WEB_CUSTOMER_UNREACHABLE || statusValues.APK_TO_WEB_CUSTOMER_UNREACHABLE)
                  && (
                  <div className="col-xs-6 negative-margin">
                    <TimePicker selectedTime={onHandleChange24hTimePicker}
                                required={required}
                                isStartTime={false}
                                restTimePicker={restTimePicker}
                                currentHour={(currentSelectedEndDateFromDB === undefined || restTimePicker) ? null : currentSelectedEndDateFromDB.getHours()}
                                currentEndTimeFromDB={currentSelectedEndDateFromDB}
                                currentMin={(currentSelectedEndDateFromDB === undefined || restTimePicker) ? null : currentSelectedEndDateFromDB.getMinutes()} />
                  </div>
                  )}
            </div>
          </div>
        </div>
        <div className="row date-reason-padding">
          <div className="col-sm-12">
            <h3>{translate('service_installation.previously_agreed_times')}</h3>
          </div>
          {editStateImportedTime.slice(0, -1)
            .map((dates, index) => {
              const date = moment(dates.startDate)
                .local()
                .format('DD.MM.YYYY');
              const startTime = moment(dates.startDate)
                .local()
                .format('HH:mm');
              const endTime = moment(dates.endDate)
                .local()
                .format('HH:mm');
              return (
                <div key={index}
                     className="col-lg-12 col-md-12"
                     style={{ paddingLeft: '50px' }}>
                  {dates.agreementStatus !== statusValues.WEB_TO_WEB_CUSTOMER_UNREACHABLE && dates.agreementStatus !== statusValues.APK_TO_WEB_CUSTOMER_UNREACHABLE
                    ? (
                      <div className="row">
                        <p className="col-sm-2">{date}</p>
                        <p className="col-sm-1">{startTime}</p>
                        <p className="col-sm-1 text-align-center"><b>-</b></p>
                        <p className="col-sm-1">{endTime}</p>
                        <p className="col-sm-3">{dates.agreementStatus ? translate(`work_list.status.${dates.agreementStatus}`) : ''}</p>
                      </div>
                    )
                    : (
                      <div className="row">
                        <p className="col-sm-2">{date}</p>
                        <p className="col-sm-1">{startTime}</p>
                        <p className="col-sm-1 text-align-center">&nbsp;</p>
                        <p className="col-sm-1" />
                        <p className="col-sm-3">{dates.agreementStatus ? translate(`work_list.status.${dates.agreementStatus}`) : ''}</p>
                      </div>
                    )}
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state = {}) => {
  const locale = state.locale || {};
  const activeLang = getActiveLanguage(locale);

  return {
    currentLanguage: (activeLang && activeLang.code) || 'fi',
    translate: getTranslate(locale),
    session: state.session.session || {},
  };
};

export default connect(
  mapStateToProps,
  null,
)(TimeData);
